import { useState } from "react";
import API from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Input } from "./ui/input";
import { PaperPlaneTilt, X } from "@phosphor-icons/react";
import { toast } from "sonner";

const stripRe = (s) => (s || "").replace(/^\s*(re|aw|fwd?)\s*:\s*/i, "").trim();

// Inline composer: answers an owner from the billing mailbox, threaded (In-Reply-To / References) — see billing_inbox.send_reply
export default function OwnerReplyComposer({ reply, smtp, onSent, onClose }) {
  const first = (reply.from_name || "").split(" ")[0];
  const [subject, setSubject] = useState(`Re: ${stripRe(reply.subject) || "Your Fixlr subscription"}`);
  const [text, setText] = useState(`Hi${first ? ` ${first}` : ""},\n\n\n\nBest regards,\nThe Fixlr team`);
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!text.trim()) { toast.error("Write a message first"); return; }
    setSending(true);
    try {
      const { data } = await API.post(`/platform/payment-recovery/inbox/${reply.id}/reply`, { subject, text });
      toast.success(`Reply sent from ${data.sent.from}${data.sent.filed_in ? " · filed in Sent" : ""}`);
      onSent(data.reply);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't send the reply");
    } finally { setSending(false); }
  };

  return (
    <div className="mt-2 rounded-md border border-border bg-background p-3 space-y-2" data-testid={`owner-reply-composer-${reply.id}`}>
      <div className="flex items-center justify-between text-[11px] text-muted-foreground">
        <span>From <strong className="text-foreground">{smtp?.from || "billing mailbox"}</strong> → {reply.from_email} · thread kept</span>
        <button type="button" onClick={onClose} className="hover:text-foreground" aria-label="Close" data-testid={`owner-reply-composer-close-${reply.id}`}><X size={12} /></button>
      </div>
      <Input value={subject} onChange={(e) => setSubject(e.target.value)} className="h-8 text-xs" data-testid={`owner-reply-composer-subject-${reply.id}`} />
      <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} className="text-xs" data-testid={`owner-reply-composer-text-${reply.id}`} />
      <div className="flex items-center justify-between">
        <p className="text-[10px] text-muted-foreground">Their message is quoted below yours, like a normal reply.</p>
        <Button size="sm" className="h-7 text-xs" onClick={send} disabled={sending || !smtp?.configured} data-testid={`owner-reply-composer-send-${reply.id}`}>
          <PaperPlaneTilt size={12} className="mr-1" /> {sending ? "Sending…" : "Send reply"}
        </Button>
      </div>
    </div>
  );
}
